"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const theme_1 = __importDefault(require("../../styles/theme"));
const styles = react_native_1.StyleSheet.create({
    container: {
        marginVertical: 15,
        flexDirection: 'row',
    },
    containerFather: {
        marginVertical: 10,
        flexDirection: 'row',
        padding: 4,
        justifyContent: 'space-around',
    },
    imageContainer: {
        flex: 1,
        justifyContent: 'center',
    },
    avatarStyle: {
        borderRadius: 0,
        backgroundColor: theme_1.default.colors.COLOR_GRAY_LIGHT,
    },
    fileNameStyle: {
        borderBottomWidth: 1,
        borderColor: theme_1.default.colors.COLOR_UNDERLINE_GRAY,
        flexDirection: 'row',
        paddingBottom: 20,
        flex: 5,
    },
    fileName: {
        alignContent: 'center',
        justifyContent: 'center',
        flex: 2,
        paddingTop: 15,
        paddingRight: 15,
    },
    iconStyle: {
        justifyContent: 'center',
        paddingTop: 15,
        marginRight: 10,
    },
    twentyVertMargin: {
        marginVertical: 20,
    },
});
exports.default = styles;
